<template>
  <v-dialog v-model="open" max-width="500px" persistent>
    <v-card flat>
      <v-card-title>
        <v-icon>mdi-delete</v-icon>
        <span>{{ t(`fraseEncerramento`) }}</span>
        <br />
      </v-card-title>
      <v-card-text>
        <v-card>
          <b-form @submit="classificar()" onsubmit="return false">
            <v-card-title> </v-card-title>
            <v-card-text>
              <v-icon>mdi-star</v-icon>
              {{ t("classificacao") }}
              <b-form-group
                id="input-group-1"
                :label="t(`classificacao`)"
                label-for="input-1"
              >
                <b-form-select
                  id="input-1"
                  v-model="classificacao"
                  required
                  @change="
                    getSubClassificacao();
                    subclassificacao = null;
                  "
                >
                  <option
                    v-for="(item, index) in classificacoes"
                    :key="index"
                    :value="{ id: item.id, nome: item.nome }"
                  >
                    {{ item.nome }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="input-group-2"
                :label="t('subClassificacao')"
                label-for="input-2"
                v-if="
                  classificacao != null &&
                  getSubClassificacao() &&
                  getSubClassificacao().length > 0
                "
              >
                <b-form-select id="input-2" v-model="subclassificacao">
                  <option
                    v-for="(item, index) in getSubClassificacao()"
                    :key="index"
                    :value="{ id: item.id, nome: item.nome }"
                  >
                    {{ item.nome }}
                  </option>
                </b-form-select>
              </b-form-group>
              <b-form-group
                id="input-group-3"
                :label="t('observacao')"
                label-for="input-3"
              >
                <b-form-textarea v-model="obs" id="input-3"></b-form-textarea>
              </b-form-group>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn text type="submit">{{ t("classificar") }}</v-btn>
            </v-card-actions>
          </b-form>
        </v-card>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn
          color="primary"
          text
          type="submit"
          :disabled="fila.obrigaClassificar && !atendimento.classificacao"
          @click="encerraAtendimento()"
          >{{ t("sim") }}</v-btn
        >
        <v-btn v-show="cancelar" color="red" text @click="cancel()">{{
          t("nao")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
   
<script>
import { mapActions } from "vuex";
import { mapState } from "vuex";

export default {
  name: "Transferencia",
  props: {
    open: { type: Boolean, default: false },
    atendimento: { type: Object, default: null },
    call: { type: Object, default: null },
    queueTypeID: { type: Number, default: 3 },
    cancelar: { type: Boolean, default: true },
    fila: { type: Object, default: null },
  },
  data() {
    return {
      ip: process.env.VUE_APP_API_URL,
      tipoForm: null,
      queue: null,
      agente: null,
      classificacoes: [],
      classificacao: null,
      subclassificacoes: [],
      subclassificacao: null,
      obs: null,
    };
  },
  computed: {
    ...mapState("auth", {
      user: (state) => state.user,
    }),
    ...mapState("sip", {
      historico: (state) => state.historico,
    }),
  },
  async created() {
    // if(this.token) this.$router.push("/main");

    await this.getClassificacao();
  },
  watch: {
    async open(nw) {
      if (nw) {
        console.log(`aqui`, this.atendimento);
        await this.getClassificacao();
        if (this.atendimento.classificacao) {
          this.classificacao = this.classificacoes
            .map((c) => {
              return { id: c.id, nome: c.nome };
            })
            .find((c) => c.nome == this.atendimento.classificacao);
        }
        if (this.atendimento.subclassificacao) {
          this.subclassificacao = this.subclassificacoes
            .map((c) => {
              return { id: c.id, nome: c.nome };
            })
            .find((c) => c.nome == this.atendimento.subclassificacao);
        }
        if (this.atendimento.obs) this.obs = this.atendimento.obs;
      }
    },
  },
  methods: {
    ...mapActions("xc", [
      "getDefault",
      "getClassificacoes",
      "getSubClassificacoes",
      "setClassificacao",
      "setClassificacaoLigacao",
      "encerrarAtendimento",
    ]),
    async getClassificacao() {
      this.classificacao = null;
      this.subclassificacao = null;
      this.obs = null;
      let item = this.atendimento;
      if (!item) item = this.call;
      if (item.observacao) this.obs = item.observacao;
      if (item.id_classificacao) {
        this.classificacao = {
          id: item.id_classificacao,
          nome: item.classificacao,
        };
      }
      if (item.id_subclassificacao) {
        this.subclassificacao = {
          id: item.id_subclassificacao,
          nome: item.subclassificacao,
        };
      }

      if (this.queueTypeID !== 1) {
        let retorno = await this.getClassificacoes(this.atendimento.queue);
        if (retorno) {
          this.classificacoes = retorno;
          this.subclassificacoes = await this.getSubClassificacoes();
          return;
        }
      }
      //item.fila = item.queue;
      let fila = item.fila ? item.fila : item.queue;
      let retorno = await this.getClassificacoes(fila);
      if (retorno) {
        this.classificacoes = retorno;
        this.subclassificacoes = await this.getSubClassificacoes();
      }
    },
    getSubClassificacao() {
      console.log(this.classificacao);

      if (this.subclassificacoes) {
        let subclassificacoes = this.subclassificacoes.filter(
          (s) => s.id_classificacao == this.classificacao.id
        );
        console.log(subclassificacoes);
        return subclassificacoes;
      } else {
        return null;
      }
    },
    classificar() {
      console.log(`classificando`, this.atendimento);
      if (this.queueTypeID === 1) {
        let dados = {};
        if (this.call)
          dados.uniqueid = this.call.uniqueid
            ? this.call.uniqueid
            : this.call.callid;
        if (!this.call) this.call = {};
        if (!dados.uniqueid) dados.uniqueid = this.atendimento.linkedid;
        this.call.classificacao = this.classificacao.nome;
        this.call.id_classificacao = this.classificacao.id;
        dados.id_classificacao = this.classificacao.id;
        if (this.subclassificacao) {
          dados.id_subclassificacao = this.subclassificacao.id;
          this.call.subclassificacao = this.subclassificacao.nome;
          this.call.id_subclassificacao = this.subclassificacao.id;
        }
        if (this.obs) {
          dados.obs = this.obs;
          this.call.obs = this.obs;
        }
        this.setClassificacaoLigacao(dados);
        if (!this.atendimento) {
          this.subclassificacao = null;
          this.classificacao = null;
          this.$emit("updateClassificar:open", false);
          return;
        }
      }
      let dados = {};
      dados.protocolo = this.atendimento.id;
      dados.data = {};
      dados.data.classificacaoID = this.classificacao.id;
      dados.data.agente = this.user.fullname;
      this.atendimento.classificacao = this.classificacao.nome;
      if (this.subclassificacao) {
        this.atendimento.subclassificacao = this.subclassificacao.nome;
        dados.data.subClassificacaoID = this.subclassificacao.id;
      }
      if (this.obs) {
        this.atendimento.obs = this.obs;
        dados.data.obs = this.obs;
      }
      this.setClassificacao(dados);
    },
    encerraAtendimento() {
      this.encerrarAtendimento(this.atendimento);
      this.$emit("updateEncerrar:open", false);
    },
    cancel() {
      this.$emit("updateEncerrar:open", false);
    },
  },
};
</script>
<style>
</style>